import React from "react";

export default function HeroBlockContainer({ children }) {
  return <div className='hero-block'>{children}</div>;
}
